export default {
    COOKIES_LIST: {
        link: '/cookies',
        title: 'Choix des cookies',
    },
    COOKIE_DETAILS: {
        link: '/cookies/:cookieId',
        title: 'Détails du cookie',
    },
};
